export class PkceChallenge {
    sha256(plain: string) {
        const encoder = new TextEncoder();
        const data = encoder.encode(plain);
        return window.crypto.subtle.digest('SHA-256', data);
    }

    base64urlencode(buffer: ArrayBuffer) {
        return btoa(String.fromCharCode.apply(null, Array.from(new Uint8Array(buffer))))
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=+$/, '');
    }

    generateRandomString() {
        const array = new Uint32Array(28);
        window.crypto.getRandomValues(array);
        return Array.from(array, (dec) => ('0' + dec.toString(16)).substr(-2)).join('');
    }

    async generateChallenge(verifier: string) {
        const hashed = await this.sha256(verifier);
        return this.base64urlencode(hashed);
    }
}
